export const GET_HANDBOOK_DATA = 'GET_HANDBOOK_DATA'
export const GET_PROVIDER_SYSTEMS_DATA = 'GET_PROVIDER_SYSTEMS_DATA'

export const GET_HANDBOOK_BY_ID = 'GET_HANDBOOK_BY_ID'
export const GET_HANDBOOK_LIST_BY_CODE = 'GET_HANDBOOK_LIST_BY_CODE'
export const DELETE_HANDBOOK_BY_CODE = 'DELETE_HANDBOOK_BY_CODE'
